import { render } from "./Infos.vue?vue&type=template&id=503afa6c&scoped=true"
import script from "./Infos.vue?vue&type=script&lang=js"
export * from "./Infos.vue?vue&type=script&lang=js"

import "./Infos.vue?vue&type=style&index=0&id=503afa6c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503afa6c"]])

export default __exports__